module.exports = "https://www.gc-qa.gnp.com.mx/e15d3da19f014afaef723d6a1cef87a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dbk_reg_back_left.png
// module id = 8095
// module chunks = 0